import styled from 'styled-components';

export const Wrap = styled.div`
  position:relative;
  background:url(${require('../../assets/img/2_21.png').default})center;
  background-size:cover;
  /* height:calc(100% - 1.06rem); */
  padding:0.75rem 0.5rem;
  section{
    width:100%;
    height:10.66rem;
    position:relative;
    background-color:#fff;
    padding:0 .57rem;
    padding-bottom:.7rem;
    .logo{
      position: absolute;
    right: -.4rem;
    top: 1.4rem;
    width: .4rem;
    z-index: 999;
    }
    h3{
      padding:.47rem 0;
      font-size:17px;
      margin-bottom:0;
    }
    .box{
      overflow-y:scroll;
      height:8.5rem;
      .answer{
        padding-bottom:.5rem;
       .question{
        position:relative;
        background-color:#005bab;
        color:#fff;
        padding:.3rem .26rem;
        font-size:.26rem;
        text-align:justify;
        line-height:1.6;
        margin-bottom:0;
        &::after{
          position:absolute;
          content:'';
          background:url(${require('../../assets/img/3_03.png').default}) center;
          background-size:100% 100%;
          width:.4rem;
          height:.4rem;
          right:0;
          bottom:0;
        }
       }
       .right{
         background-color:#e5eef6;
         color: #000;
         padding:.3rem .26rem;
         font-size:.26rem;
         text-align:justify;
         line-height:1.6;
         margin-bottom:0;
       }
       .active{
        opacity:1;
        transform:translateY(100%);
        
       }
       
       
      }

    }
  }

`